import TnCManagement from './TnCManagement'
export default TnCManagement
